module.exports = __webpack_public_path__ + "static/img/produce09.265adf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce09.png
// module id = 139
// module chunks = 4